export default __webpack_public_path__ + "static/BlackFriday-7bc945cbe7237941802677cf314009ed.svg";